import React from 'react';
import { Dialog, DialogContent, DialogTitle, Fade, IconButton, DialogActions, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SuiButton from "../../../components/SoftButton";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";


const TermsAndConditionsDialog = (props) => {

    const {i18n} = useTranslation();
    const { t } = useTranslation(['signUp', 'termsAndConditions']);
    const currentLang = i18n.language;
    const websiteURL = window?.appConfig?.REACT_APP_WEBSITE_URL || process.env.REACT_APP_WEBSITE_URL;
    const privacyURL = `${websiteURL}/${currentLang}/privacy-policy`;


    const handleScroll = (sectionId) => {
        const section = document.getElementById(sectionId);
        if (section) {
            section.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (

        <Dialog
            open={props.open}
            onClose={props.close}
            scroll="paper"
            TransitionComponent={Fade}
            aria-labelledby="terms-dialog-title"
            maxWidth="lg"
            fullWidth
        >
            <DialogTitle id="terms-dialog-title">
                {t("signUp.terms", { ns: 'signUp' })}
                <IconButton
                    aria-label="close"
                    onClick={props.close}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                        marginRight: currentLang == 'ar' ? "100px" : "0px"
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers={scroll === 'paper'}>

                <Divider/>

                {/* Table of Contents */}
                <div style={{ marginBottom: '16px', direction: currentLang == 'ar' ? 'rtl' : 'ltr' }}>
                    <strong>{t("tableOfContent", { ns: 'termsAndConditions' })}</strong>
                    <ul style={{ listStyle: 'none', paddingLeft: '0', lineHeight: '1.8', fontSize:"12px" }}>
                        <li><a href="#section1" onClick={() => handleScroll('section1')}>{t("titles.agreement", { ns: 'termsAndConditions' })}</a></li>
                        <li><a href="#section2" onClick={() => handleScroll('section2')}>{t("titles.rights", { ns: 'termsAndConditions' })}</a></li>
                        <li><a href="#section3" onClick={() => handleScroll('section3')}>{t("titles.representations", { ns: 'termsAndConditions' })}</a></li>
                        <li><a href="#section4" onClick={() => handleScroll('section4')}>{t("titles.registration", { ns: 'termsAndConditions' })}</a></li>
                        <li><a href="#section5" onClick={() => handleScroll('section5')}>{t("titles.activities", { ns: 'termsAndConditions' })}</a></li>
                        <li><a href="#section6" onClick={() => handleScroll('section6')}>{t("titles.contributions", { ns: 'termsAndConditions' })}</a></li>
                        <li><a href="#section7" onClick={() => handleScroll('section7')}>{t("titles.license", { ns: 'termsAndConditions' })}</a></li>
                        <li><a href="#section8" onClick={() => handleScroll('section8')}>{t("titles.submissions", { ns: 'termsAndConditions' })}</a></li>
                        <li><a href="#section9" onClick={() => handleScroll('section9')}>{t("titles.thirdParty", { ns: 'termsAndConditions' })}</a></li>
                        <li><a href="#section10" onClick={() => handleScroll('section10')}>{t("titles.management", { ns: 'termsAndConditions' })}</a></li>
                        <li><a href="#section11" onClick={() => handleScroll('section11')}>{t("titles.privacyPolicy", { ns: 'termsAndConditions' })}</a></li>
                        <li><a href="#section12" onClick={() => handleScroll('section12')}>{t("titles.terms", { ns: 'termsAndConditions' })}</a></li>
                        <li><a href="#section13" onClick={() => handleScroll('section13')}>{t("titles.modifications", { ns: 'termsAndConditions' })}</a></li>
                        <li><a href="#section14" onClick={() => handleScroll('section14')}>{t("titles.governing", { ns: 'termsAndConditions' })}</a></li>
                        <li><a href="#section15" onClick={() => handleScroll('section15')}>{t("titles.resolution", { ns: 'termsAndConditions' })}</a></li>
                        <li><a href="#section16" onClick={() => handleScroll('section16')}>{t("titles.correction", { ns: 'termsAndConditions' })}</a></li>
                        <li><a href="#section17" onClick={() => handleScroll('section17')}>{t("titles.disclaimer", { ns: 'termsAndConditions' })}</a></li>
                        <li><a href="#section18" onClick={() => handleScroll('section18')}>{t("titles.liability", { ns: 'termsAndConditions' })}</a></li>
                        <li><a href="#section19" onClick={() => handleScroll('section19')}>{t("titles.indemnification", { ns: 'termsAndConditions' })}</a></li>
                        <li><a href="#section20" onClick={() => handleScroll('section20')}>{t("titles.userData", { ns: 'termsAndConditions' })}</a></li>
                        <li><a href="#section21" onClick={() => handleScroll('section21')}>{t("titles.transactions", { ns: 'termsAndConditions' })}</a></li>
                        <li><a href="#section22" onClick={() => handleScroll('section22')}>{t("titles.california", { ns: 'termsAndConditions' })}</a></li>
                        <li><a href="#section23" onClick={() => handleScroll('section23')}>{t("titles.miscellaneous", { ns: 'termsAndConditions' })}</a></li>
                        <li><a href="#section24" onClick={() => handleScroll('section24')}>{t("titles.contactUs", { ns: 'termsAndConditions' })}</a></li>

                    </ul>
                </div>


                <div style={{fontSize:"14px"}}>
                    <section id="section1">
                        <strong>{t("titles.agreement", { ns: 'termsAndConditions' })}</strong>
                        <p>
                            {t("content.agreement", { ns: 'termsAndConditions' })}
                        </p>
                    </section>

                    <section id="section2">
                        <strong>{t("titles.rights", { ns: 'termsAndConditions' })}</strong>
                        <p>
                            {t("content.rights", { ns: 'termsAndConditions' })}
                        </p>
                    </section>

                    <section id="section3">
                        <strong>{t("titles.representations", { ns: 'termsAndConditions' })}</strong>
                        <p>
                            {t("content.representations", { ns: 'termsAndConditions' })}
                        </p>
                    </section>

                    <section id="section4">
                        <strong>{t("titles.registration", { ns: 'termsAndConditions' })}</strong>
                        <p>
                            {t("content.registration", { ns: 'termsAndConditions' })}
                        </p>
                    </section>

                    <section id="section5">
                        <strong>{t("titles.activities", { ns: 'termsAndConditions' })}</strong>
                        <p>
                            {t("content.activities", { ns: 'termsAndConditions' })}
                        </p>
                    </section>

                    <section id="section6">
                        <strong>{t("titles.contributions", { ns: 'termsAndConditions' })}</strong>
                        <p>
                            {t("content.contributions", { ns: 'termsAndConditions' })}
                        </p>
                    </section>

                    <section id="section7">
                        <strong>{t("titles.license", { ns: 'termsAndConditions' })}</strong>
                        <p>
                            {t("content.license", { ns: 'termsAndConditions' })}
                        </p>
                    </section>

                    <section id="section8">
                        <strong>{t("titles.submissions", { ns: 'termsAndConditions' })}</strong>
                        <p>
                            {t("content.submissions", { ns: 'termsAndConditions' })}
                        </p>
                    </section>

                    <section id="section9">
                        <strong>{t("titles.thirdParty", { ns: 'termsAndConditions' })}</strong>
                        <p>
                            {t("content.thirdParty", { ns: 'termsAndConditions' })}
                        </p>
                    </section>

                    <section id="section10">
                        <strong>{t("titles.management", { ns: 'termsAndConditions' })}</strong>
                        <p>
                            {t("content.management", { ns: 'termsAndConditions' })}
                        </p>
                    </section>

                    <section id="section11">
                        <strong>{t("titles.privacyPolicy", { ns: "termsAndConditions" })}</strong>
                        <p>
                            {t("content.privacyPolicy", { ns: "termsAndConditions" })}{" "}
                            <a
                                href={privacyURL}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: "#6a1b9a", textDecoration: "underline" }}
                            >
                                {t("content.privacyPolicy.learnMore", { ns: "termsAndConditions" })}
                            </a>
                        </p>
                    </section>

                    <section id="section12">
                        <strong>{t("titles.terms", { ns: 'termsAndConditions' })}</strong>
                        <p>
                            {t("content.terms", { ns: 'termsAndConditions' })}
                        </p>
                    </section>

                    <section id="section13">
                        <strong>{t("titles.modifications", { ns: 'termsAndConditions' })}</strong>
                        <p>
                            {t("content.modifications", { ns: 'termsAndConditions' })}
                        </p>
                    </section>

                    <section id="section14">
                        <strong>{t("titles.governing", { ns: 'termsAndConditions' })}</strong>
                        <p>
                            {t("content.governing", { ns: 'termsAndConditions' })}
                        </p>
                    </section>

                    <section id="section15">
                        <strong>{t("titles.resolution", { ns: 'termsAndConditions' })}</strong>
                        <p>
                            {t("content.resolution", { ns: 'termsAndConditions' })}
                        </p>
                    </section>

                    <section id="section16">
                        <strong>{t("titles.correction", { ns: 'termsAndConditions' })}</strong>
                        <p>
                            {t("content.correction", { ns: 'termsAndConditions' })}
                        </p>
                    </section>

                    <section id="section17">
                        <strong>{t("titles.disclaimer", { ns: 'termsAndConditions' })}</strong>
                        <p>
                            {t("content.disclaimer", { ns: 'termsAndConditions' })}
                        </p>
                    </section>

                    <section id="section18">
                        <strong>{t("titles.liability", { ns: 'termsAndConditions' })}</strong>
                        <p>
                            {t("content.liability", { ns: 'termsAndConditions' })}
                        </p>
                    </section>

                    <section id="section19">
                        <strong>{t("titles.indemnification", { ns: 'termsAndConditions' })}</strong>
                        <p>
                            {t("content.indemnification", { ns: 'termsAndConditions' })}
                        </p>
                    </section>

                    <section id="section20">
                        <strong>{t("titles.userData", { ns: 'termsAndConditions' })}</strong>
                        <p>
                            {t("content.userData", { ns: 'termsAndConditions' })}
                        </p>
                    </section>

                    <section id="section21">
                        <strong>{t("titles.transactions", { ns: 'termsAndConditions' })}</strong>
                        <p>
                            {t("content.transactions", { ns: 'termsAndConditions' })}
                        </p>
                    </section>


                    <section id="section22">
                        <strong>{t("titles.california", { ns: 'termsAndConditions' })}</strong>
                        <p>
                            {t("content.california", { ns: 'termsAndConditions' })}
                        </p>
                    </section>


                    <section id="section23">
                        <strong>{t("titles.miscellaneous", { ns: 'termsAndConditions' })}</strong>
                        <p>
                            {t("content.miscellaneous", { ns: 'termsAndConditions' })}
                        </p>
                    </section>


                    <section id="section24">
                        <strong>{t("titles.contactUs", { ns: 'termsAndConditions' })}</strong>
                        <p>
                            {t("content.contactUs", { ns: 'termsAndConditions' })}
                            <br />
                            <br />
                            <strong>YaiGlobal</strong>
                            <br />
                            5201 Great America Parkway
                            <br />
                            {t("content.address", { ns: 'termsAndConditions' })}
                            <br />
                            {t("content.US", { ns: 'termsAndConditions' })}
                            <br />
                            <strong>{t("content.phone", { ns: 'termsAndConditions' })}</strong> +1 (319) 777-4015
                            <br />
                            <strong>{t("content.email", { ns: 'termsAndConditions' })}</strong> info@yaiglobal.com
                        </p>
                    </section>

                </div>
            </DialogContent>

            <Divider/>

            <DialogActions>
                <SuiButton variant="gradient" color="primary" size="medium" type="submit" onClick={props.close}>
                    {t("buttons.dialogActions.accept", { ns: 'common' })}
                </SuiButton>
            </DialogActions>

        </Dialog>

    );
};

TermsAndConditionsDialog.propTypes = {
    open: PropTypes.bool,
    close: PropTypes.func
}

export default TermsAndConditionsDialog;
